export const CONSTANTS_LOAD = 'CONSTANTS_LOAD'
export const CONSTANTS_LOAD_FULFILLED = 'CONSTANTS_LOAD_FULFILLED'
export const CONSTANTS_LOAD_PENDING = 'CONSTANTS_LOAD_PENDING'
export const CONSTANTS_LOAD_REJECTED = 'CONSTANTS_LOAD_REJECTED'

export const DOWNLOAD_FILE = 'DOWNLOAD_FILE'
export const DOWNLOAD_FILE_FULFILLED = 'DOWNLOAD_FILE_FULFILLED'
export const DOWNLOAD_FILE_REJECTED = 'DOWNLOAD_FILE_REJECTED'
export const DOWNLOAD_FILE_PENDING = 'DOWNLOAD_FILE_PENDING'
